<template>
	<div class="body">
		
		
		<a-row>
		      <a-col :span="12">
		        <div class="loginTitle">
					<img style="width: 72px;border-radius: 45px;" src="../static/logo.png" alt="">
					<span style="color: white;">&nbsp;&nbsp;帝全会员管理后台</span>
				</div>
		      </a-col>
		      <a-col :span="12">
		        <div class="loginFrame">
		        	<div class="login">
		        		<!-- <div class="top"><img id="bicycle" height="95" src="../static/shop.png" /></div> -->
						<h1 style="text-align: center;">欢迎登陆</h1>
		        		<a-form id="store-login" :form="form" class="login-form" @submit="handleSubmit">
		        			<a-form-item>
		        				<a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入你的账号!' }] }]" placeholder="用户名/手机号">
		        					<a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
		        				</a-input>
		        			</a-form-item>
		        			<a-form-item>
		        				<a-input v-decorator="['password', { rules: [{ required: true, message: '请输入你的密码!' }] }]" type="password" placeholder="密码">
		        					<a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
		        				</a-input>
		        			</a-form-item>
		        			<a-row>
		        				<a-col :span="14">
		        					<a-form-item>
		        						<a-input v-decorator="['identifyCode', { rules: [{ required: true, message: '请输入验证码!' }] }]" placeholder="验证码">
		        							<a-icon slot="prefix" type="insurance" style="color: rgba(0,0,0,.25)" />
		        						</a-input>
		        					</a-form-item>
		        				</a-col>
		        				<a-col :span="10">
		        					<div class="coderight" @click="refreshCode"><SIdentify :identifyCode="identifyCode" @click="refreshCode"></SIdentify></div>
		        				</a-col>
		        			</a-row>
		        			<a-row v-if="isNeedCode">
		        				<a-col :span="14">
		        					<a-form-item>
		        						<a-input v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入手机验证码!' }] }]" placeholder="手机验证码">
		        							<a-icon slot="prefix" type="insurance" style="color: rgba(0,0,0,.25)" />
		        						</a-input>
		        					</a-form-item>
		        				</a-col>
		        				<a-col :span="10">
		        					<div class="coderight" @click="getCode">
		        						<a-button type="primary" :disabled="sendCode">发送验证码
		        						<span v-if="timeTemp != 0">
		        							{{ timeTemp }}
		        						</span>
		        						</a-button>
		        					</div>
		        				</a-col>
		        			</a-row>
		        
		        			<a-form-item><a-button type="primary" html-type="submit" block>登录</a-button></a-form-item>
		        		</a-form>
		        	</div>
		        </div>
		      </a-col>
		</a-row>
	</div>
</template>

<script>
import axios from 'axios';
import SIdentify from '../components/utils/identify.vue';
import api from '../api/Api.js'

export default {
	data() {
		return {
			name: '',
			identifyCodes: '1234567890',
			identifyCode: '',
			sendCode: false,
			timeTemp: 0,
			account:'',
			isNeedCode:false,
			isSetCookie:true,
			errorPassTemp:0
		};
	},
	components: {
		SIdentify: SIdentify
	},
	beforeCreate() {
		this.form = this.$form.createForm(this, { name: 'store-login' });
	},
	mounted() {		
		this.identifyCode = '';
		this.makeCode(this.identifyCodes, 4);
		localStorage.removeItem('accessToken')
		localStorage.removeItem('Flag')
		localStorage.removeItem('username');
		localStorage.removeItem('avatar');
		localStorage.removeItem('accountId');
	},
	methods: {
		handleSubmit(e) {
			const that = this;
			e.preventDefault();
			this.form.validateFields((err, values) => {

				if(values.identifyCode != that.identifyCode){
					 this.$message.error("验证码错误")
					 return;
				}

				if (!err) {
					let url = 'api/login/v1/login/storeLogin';
					let parm = {
						countryCode: 86,
						latitude: 40.22077,
						longitude: 116.397128,
						password: values.password,
						phone: values.userName,
						verifyCode: values.verifyCode
					};
					that.account = parm.phone;
					
					var cookie = that.getCookie(that.account);
					if(that.isSetCookie && cookie == null){
						that.isNeedCode = true;
						that.isSetCookie = false;
						this.$message.warning("登录状态过期，需要获取验证码~")
						return;
					}
					
					api.postRequest(url,parm, res => {
						if (res.data.status == 200) {
							
							that.setCookie(that.account,that.account);
							
							const data = res.data.data;
							const accessToken = data.token;
							this.$store.commit('setToken', accessToken);
							localStorage.setItem('accessToken', accessToken);
							
							localStorage.setItem('level2', data.level2);
							localStorage.setItem('level3', data.level3);
							localStorage.setItem('level4', data.level4);
							
							localStorage.setItem('phone', that.account);
							
							//设置Vuex登录标志为true，默认userLogin为false
							this.$store.dispatch('userLogin', true);
							//Vuex在用户刷新的时候userLogin会回到默认值false，所以我们需要用到HTML5储存
							//我们设置一个名为Flag，值为isLogin的字段，作用是如果Flag有值且为isLogin的时候，证明用户已经登录了。
							localStorage.setItem('Flag', 'isLogin');
							this.getInfo();
						} else{
							this.$message.error(res.data.message);
							that.errorPassTemp ++;
							console.log(that.errorPassTemp)
							if(that.errorPassTemp >= 2){
								that.delCookie(that.account);
							}
							that.refreshCode();
						}
					});
				}
			});
		},
		getInfo() {

			let url = 'api/member/v1/general/admin/get';
			let parm = '1';

			api.postRequest(url,parm, res => {
				// console.log("========================================")
				// console.log(res);
				// console.log(localStorage.getItem('accessToken'))
				if (res.data.status == 200) {
					const rest = res.data.data;
					
					localStorage.setItem('username', rest.lastName + rest.firstName);
					localStorage.setItem('avatar', rest.avatar);
					localStorage.setItem('accountId', rest.accountId);
					
					this.$message.success('登录成功！');
					//登录成功后跳转到指定页面
					this.$router.push('/index');
				}else{
					this.$message.error(rest.message);
				}
			});
		},
		//验证码abcdefghijklnmopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ
		randomNum(min, max) {
			return Math.floor(Math.random() * (max - min) + min);
		},
		refreshCode() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
		},
		makeCode(o, l) {
			for (let i = 0; i < l; i++) {
				this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
			}
		},
		getCode(){
			const that = this;
			
			that.timeTemp = 60;
			
			this.sendCode = true;		
			var myVar = setInterval(function(){ myTimer() }, 1000);
			 
			function myTimer() {
			    that.timeTemp --;
				if(that.timeTemp == 0){
					myStopFunction();
				}
			}
			 
			function myStopFunction() {
			    clearInterval(myVar);
				that.sendCode = false;
			}
			
			this.form.validateFields((err, values) => {
				let url = 'api/login/v1/login/VerificationCodeParam';
				let parm = {
					phone: values.userName
				};
				api.postRequest(url,parm, res => {
				});
			})
		},
		//JS操作cookies方法!
		//写cookies
		setCookie(name,value){
			var Days = 3;
			var exp = new Date(); 
			exp.setTime(exp.getTime() + Days*24*60*60*1000);
			document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
		},
		//读取cookies
		getCookie(name){
			var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
			if(arr=document.cookie.match(reg)) return unescape(arr[2]);
			else return null;
		},
		//删除cookies
		delCookie(name){
			var exp = new Date();
			exp.setTime(exp.getTime() - 1);
			var cval=this.getCookie(name);
			if(cval!=null) document.cookie= name + "="+cval+";expires="+exp.toGMTString();
		},
	}
};
</script>

<style scoped>
#components-form-demo-normal-login .login-form {
	max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
	float: right;
}
#components-form-demo-normal-login .login-form-button {
	width: 100%;
}
.login {
	width: 300px;
	margin: 0px auto;
}
.top {
	margin-bottom: 20px;
	text-align: center;
}
.loginFrame {
	width: 400px;
	padding-top: 25px;
	padding-bottom: 30px;
	margin: 0 auto;
	border: 6px solid white;
	background-color: white;
	margin-top: 180px;
}

.loginTitle{
	width: 400px;
	padding-top: 25px;
	padding-bottom: 30px;
	margin: 0 auto;
	margin-top: 120px;
	font-size: 28px;
	font-weight: bold;
	letter-spacing:8px;
}
.body {
	background: url('../static/img/bg.jpg') repeat-y center;
	width: 100%;
	height: 100vh; /* 重点一 */
	background-repeat: no-repeat;
	background-size: cover; /* 重点二 */
}
.coderight {
	margin-left: 10px;
}
</style>
